import { render, staticRenderFns } from "./job-detail.vue?vue&type=template&id=11a6875e&scoped=true&"
import script from "./job-detail.vue?vue&type=script&lang=js&"
export * from "./job-detail.vue?vue&type=script&lang=js&"
import style0 from "./job-detail.vue?vue&type=style&index=0&id=11a6875e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6875e",
  null
  
)

export default component.exports